// eslint-disable-next-line import/no-unresolved
import { wishlistStore } from '@common-vue/add-to-wishlist';

export default {
  namespaced: true,
  state() {
    return {
      ...wishlistStore.state,
    };
  },
  getters: {
    ...wishlistStore.getters,
  },
  mutations: {
    ...wishlistStore.mutations,
  },
  actions: {
    ...wishlistStore.actions,
  },
};
